export default "__VITE_ASSET__$nz_nTWG__"